module.exports = __webpack_public_path__ + "static/img/badge.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/badge.png
// module id = s0WH
// module chunks = 0